export const portfolioData = {
    bio: {
      name: "Ferhat Kochan",
      description: {
        part1: "Hi! I'm an engineer and entrepreneur with experience spanning over multiple industries such as tradfi, crypto, real estate and data analytics. Currently, I lead technical content and documentation at QuickNode, a leading web3 infrastructure platform, where I focus on creating technical resources and improving the developer experience.",
        part2: "Check out the tabs above to learn more about my work and interests.",
        part3: <>Want to connect? Reach out via <a href="mailto:contact@ferhat.pro" className="text-green-500 hover:text-green-400 transition-colors">email</a> or <a href="https://t.me/OxCrispy" className="text-green-500 hover:text-green-400 transition-colors">Telegram</a>.</>
      }
    },
    projects: [
      {
        title: "Neural Network Visualizer",
        description: "Interactive tool for visualizing neural networks",
        tech: ["React", "Three.js", "TensorFlow.js"],
        link: "#"
      },
      {
        title: "Crypto Portfolio Tracker",
        description: "Real-time cryptocurrency portfolio management",
        tech: ["React", "Node.js", "MongoDB"],
        link: "#"
      }
    ],
    writing: {
        intro: "A collection of thoughts and resources I've written over time.",
        guides: [
          {
            title: "Accident Analysis",
            url: "https://ferhatkochan.medium.com/accident-analysis-a87cbec41698",
            category: "Data Analytics"
          },
          {
            title: "Using Transfer Learning to Detect Lung Infections",
            url: "https://ferhatkochan.medium.com/using-transfer-learning-to-detect-lung-infections-f1c2df4a4138",
            category: "Data Analytics"
          },
          {
            title: "Things to Know About the Data Science Process",
            url: "https://ferhatkochan.medium.com/things-to-know-about-the-data-science-process-f5817c99049c",
            category: "Data Analytics"
          },
          {
            title: "Building Dockerfiles to deploy Flask Apps",
            url: "https://ferhatkochan.medium.com/things-to-know-about-the-data-science-process-f5817c99049c",
            category: "Data Analytics"
          },
          {
            title: "Big Data: Part 1",
            url: "https://ferhatkochan.medium.com/big-data-part-1-438df9b31557",
            category: "Data Analytics"
          },
          {
            title: "How to listen to Smart Contract Events with Web3.js",
            url: "https://ferhatkochan.medium.com/how-to-listen-to-smart-contract-events-with-web3js-345608f916c4",
            category: "Web3"
          },
          {
            title: "Intro to Zero-Knowledge Proofs",
            url: "https://www.quicknode.com/guides/custom-chains/intro-to-zero-knowledge-proofs",
            category: "Web3"
          },
          {
            title: "How to Create Hooks on Uniswap V4",
            url: "https://www.quicknode.com/guides/defi/dexs/how-to-create-uniswap-v4-hooks",
            category: "Web3"
          },
          {
            title: "How to Swap Tokens on Uniswap V3",
            url: "https://www.quicknode.com/guides/defi/dexs/how-to-swap-tokens-on-uniswap-v3",
            category: "Web3"
          },
          {
            title: "How to Swap Tokens on Uniswap V2 with Ethers.js",
            url: "https://www.quicknode.com/guides/defi/dexs/how-to-swap-tokens-on-uniswap-with-ethersjs",
            category: "Web3"
          },
          {
            title: "What is DeFi?",
            url: "https://www.quicknode.com/guides/defi/getting-started/what-is-defi",
            category: "Web3"
          },
          {
            title: "How to Build a React Frontend with wagmi",
            url: "https://www.quicknode.com/guides/ethereum-development/dapps/building-dapps-with-wagmi",
            category: "Web3"
          },
          {
            title: "How to Create a Web3 Chrome Extension",
            url: "https://www.quicknode.com/guides/ethereum-development/dapps/create-a-web3-chrome-extension",
            category: "Web3"
          },
          {
            title: "How to Create an ERC-20 Token Factory dApp",
            url: "https://www.quicknode.com/guides/ethereum-development/dapps/how-to-create-an-evm-token-factory-dapp",
            category: "Web3"
          },
          {
            title: "What are Ethereum Accounts?",
            url: "https://www.quicknode.com/guides/ethereum-development/getting-started/what-are-ethereum-accounts",
            category: "Web3"
          },
          {
            title: "What is the Ethereum Virtual Machine (EVM)?",
            url: "https://www.quicknode.com/guides/ethereum-development/getting-started/what-is-the-ethereum-virtual-machine-evm",
            category: "Web3"
          },
          {
            title: "What is MEV?",
            url: "https://www.quicknode.com/guides/ethereum-development/MEV/what-is-mev",
            category: "Web3"
          },
          {
            title: "How to Create and Deploy an Upgradeable ERC20 Token",
            url: "https://www.quicknode.com/guides/ethereum-development/smart-contracts/how-to-create-and-deploy-an-upgradeable-erc20-token",
            category: "Web3"
          },
          {
            title: "Predicting Contract Addresses on Multiple Networks with Solidity's CREATE2",
            url: "https://www.quicknode.com/guides/ethereum-development/smart-contracts/how-to-use-create2-to-predetermine-contract-addresses",
            category: "Web3"
          },
          {
            title: "The Diamond Standard (EIP-2535) Explained - Part 1",
            url: "https://www.quicknode.com/guides/ethereum-development/smart-contracts/the-diamond-standard-eip-2535-explained-part-1",
            category: "Web3"
          },
          {
            title: "The Diamond Standard (EIP-2535) Explained - Part 2",
            url: "https://www.quicknode.com/guides/ethereum-development/smart-contracts/the-diamond-standard-eip-2535-explained-part-2",
            category: "Web3"
          },
          {
            title: "Transaction Calldata Demystified",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/ethereum-transaction-calldata",
            category: "Web3"
          },
          {
            title: "Filter Mempool Transactions on Ethereum",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/how-to-filter-mempool-transactions-on-ethereum",
            category: "Web3"
          },
          {
            title: "What is a Nonce? (& Management Techniques)",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/how-to-manage-nonces-with-ethereum-transactions",
            category: "Web3"
          },
          {
            title: "How to Send ERC-20 Tokens using Web3.py and Python",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/how-to-send-erc20-tokens-using-web3py",
            category: "Web3"
          },
          {
            title: "ERC-20 Permit Approval (without Gas!)",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/how-to-use-erc20-permit-approval",
            category: "Web3"
          },
          {
            title: "Account Abstraction and ERC-4337 - Part 1",
            url: "https://www.quicknode.com/guides/ethereum-development/wallets/account-abstraction-and-erc-4337-pt-1",
            category: "Web3"
          },
          {
            title: "Account Abstraction and ERC-4337 - Part 2",
            url: "https://www.quicknode.com/guides/ethereum-development/wallets/account-abstraction-and-erc-4337-pt-2",
            category: "Web3"
          },
          {
            title: "Private Transactions",
            url: "https://www.quicknode.com/guides/ethereum-development/wallets/how-to-use-stealth-addresses-on-ethereum-eip-5564",
            category: "Web3"
          },
          {
            title: "Manage WSS Connections on Ethereum Node",
            url: "https://www.quicknode.com/guides/ethereum-development/transactions/how-to-manage-nonces-with-ethereum-transactions",
            category: "Web3"
          },
          {
            title: "How to Use Streams & Functions to Monitor Borrowers on Aave",
            url: "https://www.quicknode.com/guides/quicknode-products/functions/how-to-use-functions-to-monitor-aave-positions",
            category: "Web3"
          },
          {
            title: "How to Build Your Own Indexer and API for Contract Deployment Details",
            url: "https://www.quicknode.com/guides/quicknode-products/streams/contract-deployment-lists-with-streams-and-key-value-store",
            category: "Web3"
          },
          {
            title: "How to Create a Uniswap Bot with Streams & Filters",
            url: "https://www.quicknode.com/guides/quicknode-products/streams/how-to-create-a-uniswap-bot-with-streams-filters",
            category: "Web3"
          },
          {
            title: "Become a Web3 Developer Roadmap",
            url: "https://www.quicknode.com/guides/web3-fundamentals-security/how-to-become-a-web3-developer-roadmap",
            category: "Web3"
          }
        ]
    },
    /*
    books: [
      {
        title: "Tech Conference Talk",
        type: "Presentation",
        link: "#"
      },
      {
        title: "Open Source Contribution",
        type: "Code",
        link: "#"
      }
    ]
    */
  };